export default "__VITE_ASSET__BMHHZ5Ja__"